import router from "./router";
import store from "@/store";

router.beforeEach(async (to, from, next) => {
  if (
    to.path != "/" &&
    store.state.Config.studentType !== "new" &&
    store.getters["oidcStore/oidcIsAuthenticated"] &&
    !store.getters["oidcStore/oidcIdToken"]
  ) {
    store.dispatch("oidcStore/signOutOidc");
    next({ path: "/" });
  } else if (to.path != "/" && store.state.Config.studentType === "") {
    next({ path: "/" });
  } else {
    next();
  }
});

router.afterEach();
